var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApyBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 286,
    viewBox: "0 0 275 286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.52,
    filter: "url(#filter0_f_686_557)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.2 162.565C175.073 181.783 177.408 210.671 152.373 210.026C127.637 209.389 126.318 179.935 115.111 160.863C100.098 135.315 60.4159 108.394 81.5919 89.5747C106.824 67.1508 157.794 72.371 188.975 95.22C213.375 113.1 188.761 138.848 181.2 162.565Z",
    fill: "url(#paint0_linear_686_557)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_686_557",
    x: 0.503906,
    y: 0.177612,
    width: 274.004,
    height: 284.859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.5,
    result: "effect1_foregroundBlur_686_557"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_686_557",
    x1: 189.741,
    y1: 154.661,
    x2: 69.4745,
    y2: 122.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9859"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApyBg);
export default __webpack_public_path__ + "static/media/apy-bg.f0363304381884b9212204a351fa2cd8.svg";
export { ForwardRef as ReactComponent };